var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSbitLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "6px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100.8 109.6"
    },
    xmlSpace: "preserve",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.sbit0{fill:#40B93C;}\n\t.sbit1{fill:#73CC7D;}\n\t.sbit2{fill:#0DAA4C;}\n\t.sbit3{fill:#D9EEA8;}\n\t.sbit4{fill:#66C64E;}\n\t.sbit5{fill:#009748;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-561.5992,-588.07441)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path390",
    className: "sbit0",
    d: "M616.4,598.4l-10.5,40.2l0,16.8l10.5,40.1v-30.2l-7-10v-16.8l7-10L616.4,598.4L616.4,598.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path394",
    className: "sbit1",
    d: "M626.9,613.6l-10.5,15v8.6l10.5-4.2V613.6 M616.4,656.7v8.6l10.5,15v-19.4L616.4,656.7 L616.4,656.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path398",
    className: "sbit2",
    d: "M616.4,628.5l-7,10v16.8l7,10v-8.6l-3.5-1.4v-16.8l3.5-1.4V628.5L616.4,628.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path402",
    className: "sbit3",
    d: "M637.4,628.7l-10.5,4.2v28l10.5,4.2V628.7L637.4,628.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path406",
    className: "sbit4",
    d: "M626.9,632.9l-10.5,4.2v19.6l10.5,4.2V632.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path410",
    className: "sbit5",
    d: "M616.4,637.1l-3.5,1.4v16.8l3.5,1.4V637.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path414",
    className: "sbit3",
    d: "M583.1,631.5l0,30.8l10.5-4.2v-22.4L583.1,631.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path418",
    className: "sbit1",
    d: "M593.6,623.6v12.1l7,2.8v16.8l-7,2.8v12.2l10.5-15v-16.8L593.6,623.6L593.6,623.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path422",
    className: "sbit4",
    d: "M593.6,635.7v22.4l7-2.8v-16.8L593.6,635.7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSbitLogo);
export default __webpack_public_path__ + "static/media/SBIT_logo.26f0c89ddb09dd2fecd15ed02abbdbe8.svg";
export { ForwardRef as ReactComponent };